<template>
  <div v-if="isVisible" class="Description">
    <p v-if="field.hasHtml" v-html="field.text"></p>
    <p v-else v-text="field.text"></p>
  </div>
</template>

<script>
import FormItem from '../../mixins/FormItem'

export default {
  name: 'Description',
  mixins: [FormItem],
}
</script>

<style lang="scss" scoped>
@use '../../css/foundation/vars';

.Description {
  font-size: 1.6rem;

  ::v-deep a {
    color: vars.$color-btn-accept;
    text-decoration: underline;
    transition: filter 0.2s ease;

    &:hover {
      filter: brightness(1.3);
    }
  }
}
</style>
